import React from "react";
import {
  LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid, ResponsiveContainer,
  BarChart, Bar, Legend
} from "recharts";

import {
  FaUserGraduate,
  FaChalkboardTeacher,
  FaClipboardCheck,
  FaRupeeSign,
  FaBullhorn,
  FaMoneyBillWave,
  FaUserPlus
} from "react-icons/fa";
import { FaCommentDots } from "react-icons/fa";
import { MdPersonAddAlt } from "react-icons/md";

export default function Dashboard() {

  const attendanceData = [
    { day: "Sat", present: 85, absent: 80 },
    { day: "Sun", present: 15, absent: 35 },
    { day: "Mon", present: 40, absent: 90 },
    { day: "Tue", present: 45, absent: 50 },
    { day: "Wed", present: 75, absent: 20 },
    { day: "Thu", present: 60, absent: 30 },
    { day: "Fri", present: 78, absent: 10 },
  ];

  const enrollmentData = [
    { month: "Jan", male: 45, female: 90 },
    { month: "Feb", male: 80, female: 65 },
    { month: "Mar", male: 25, female: 45 },
    { month: "Apr", male: 90, female: 90 },
    { month: "May", male: 35, female: 65 },
    { month: "Jun", male: 88, female: 60 },
  ];

  return (
    <>
      <style>{`
        .dashboard-container {
          padding: 20px;
          background: #f5f7fb;
          font-family: Arial;
        }

        .cards {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
          gap: 20px;
          margin-bottom: 25px;
        }
.card {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  padding: 20px;
  border-radius: 16px;
  border: 1px solid rgba(255,255,255,0.2);
  box-shadow: 0 8px 25px rgba(0,0,0,0.15);
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.3s ease;
  color: white;
}

/* GRADIENT COLORS */
.card:nth-child(1) {
  background: linear-gradient(135deg, rgba(9, 137, 248, 0.8), rgba(0,242,254,0.8));
}

.card:nth-child(2) {
  background: linear-gradient(135deg, rgba(2, 244, 83, 0.8), rgba(56,249,215,0.8));
}

.card:nth-child(3) {
  background: linear-gradient(135deg, rgba(247, 20, 88, 0.8), rgba(254,225,64,0.8));
}

.card:nth-child(4) {
  background: linear-gradient(135deg, rgba(17, 43, 161, 0.8), rgba(118,75,162,0.8));
}

/* HOVER GLOW EFFECT */
.card:hover {
  transform: translateY(-6px) scale(1.02);
  box-shadow: 0 12px 30px rgba(0,0,0,0.25),
              0 0 15px rgba(255,255,255,0.2);
}

/* TEXT COLORS */
.card h4 {
  color: rgba(255,255,255,0.85);
}

.card span {
  color: #eaffea;
}

        .card:hover, .chart-card:hover {
          transform: translateY(-4px);
        }

        .card h4 {
          margin: 0;
          font-size: 14px;
          color: gray;
        }

        .card h2 {
          margin: 5px 0;
        }

        .card span {
          font-size: 12px;
          color: green;
        }

        .icon-box {
          width: 45px;
          height: 45px;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 20px;
        }

        .blue { background: linear-gradient(45deg,#4facfe,#00f2fe); }
        .green { background: linear-gradient(45deg,#43e97b,#38f9d7); }
        .pink { background: linear-gradient(45deg,#fa709a,#fee140); }
        .purple { background: linear-gradient(45deg,#667eea,#764ba2); }

        .charts {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 20px;
        }

        .chart-card {
          background: white;
          padding: 20px;
          border-radius: 12px;
          box-shadow: 0 4px 12px rgba(0,0,0,0.08);
          transition: 0.3s;
        }

        .chart-title {
          font-weight: bold;
          margin-bottom: 10px;
        }

        /* BOTTOM SECTION */
        .bottom-section {
          display: grid;
          grid-template-columns: 2fr 1fr;
          gap: 20px;
          margin-top: 20px;
        }

        .announcement-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 12px;
          border-radius: 8px;
          background: #f9fafc;
          margin-bottom: 10px;
        }

        .announcement-item span {
          display: flex;
          align-items: center;
        }

        .badge {
          font-size: 11px;
          padding: 4px 8px;
          border-radius: 6px;
          color: white;
        }

        .exam { background: #4facfe; }
        .event { background: #43e97b; }
        .important { background: #ff6b6b; }

        .fee-box {
          text-align: center;
        }

        .circle {
          width: 120px;
          height: 120px;
          border-radius: 50%;
          background: conic-gradient(#43e97b 81%, #eaeaea 0%);
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
          font-size: 20px;
          margin: auto;
        }

        .fee-stats {
          display: flex;
          justify-content: space-between;
          margin-top: 15px;
          font-size: 13px;
        } 
          
        .progress-bar {
          height: 6px;
          background: #eaeaea;
          border-radius: 10px;
          margin-top: 10px;
        }

        .progress-fill {
          height: 100%;
          width: 81%;
          background: #43e97b;
          border-radius: 10px;
        }

        .activities {
          margin-top: 20px;
        }

        .activity-item {
          display: flex;
          gap: 10px;
          margin-bottom: 12px;
          align-items: center;
        }
          .activity-icon { 
          width: 32px;
          height: 32px;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          }

.icon-blue { background: #e6f0ff; color: #4facfe; }
.icon-green { background: #e8fff3; color: #43e97b; }
.icon-pink { background: #ffe8f0; color: #fa709a; }
.icon-orange { background: #fff3e6; color: #ff9f43; }

.card {
  transition: all 0.4s ease;
}

.card:hover {
  transform: translateY(-8px) scale(1.03);
}

        /* RESPONSIVE */
        @media (max-width: 768px) {
          .charts {
            grid-template-columns: 1fr;
          }
          .bottom-section {
            grid-template-columns: 1fr;
          }
        }
      `}</style>

      <div className="dashboard-container">

        {/* TOP CARDS */}
        <div className="cards">
          <div className="card">
            <div>
              <h4>Total Students</h4>
              <h2>1,845</h2>
              <span>+12% vs last month</span>
            </div>
            <div className="icon-box blue"><FaUserGraduate /></div>
          </div>

          <div className="card">
            <div>
              <h4>Active Teachers</h4>
              <h2>124</h2>
              <span>+5% vs last month</span>
            </div>
            <div className="icon-box green"><FaChalkboardTeacher /></div>
          </div>

          <div className="card">
            <div>
              <h4>Attendance Today</h4>
              <h2>94.2%</h2>
              <span>+2.1% vs last month</span>
            </div>
            <div className="icon-box pink"><FaClipboardCheck /></div>
          </div>

          <div className="card">
            <div>
              <h4>Pending Fees</h4>
              <h2>₹48,500</h2>
              <span style={{ color: "red" }}>-8% vs last month</span>
            </div>
            <div className="icon-box purple"><FaRupeeSign /></div>
          </div>
        </div>

        {/* CHARTS */}
        <div className="charts">

          <div className="chart-card">
            <div className="chart-title">Attendance Trend</div>
            <ResponsiveContainer width="100%" height={250}>
              <LineChart data={attendanceData}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="day" />
                <YAxis />
                <Tooltip />
                <Line type="monotone" dataKey="present" stroke="#4facfe" strokeWidth={3} />
                <Line type="monotone" dataKey="absent" stroke="#43e97b" strokeWidth={3} />
              </LineChart>
            </ResponsiveContainer>
          </div>

          <div className="chart-card">
            <div className="chart-title">Student Enrollment Growth</div>
            <ResponsiveContainer width="100%" height={250}>
              <BarChart data={enrollmentData}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="month" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Bar dataKey="male" fill="#4facfe" />
                <Bar dataKey="female" fill="#43e97b" />
              </BarChart>
            </ResponsiveContainer>
          </div>

        </div>

        {/* BOTTOM SECTION */}
        <div className="bottom-section">

          <div className="chart-card">
            <div className="chart-title">Announcements & Events</div>

            <div className="announcement-item">
              <span><FaBullhorn style={{ marginRight: 8 }} />Mid-Term Exams Schedule Released</span>
              <span className="badge exam">Exam</span>
            </div>

            <div className="announcement-item">
              <span><FaBullhorn style={{ marginRight: 8 }} />Parent-Teacher Conference</span>
              <span className="badge event">Event</span>
            </div>

            <div className="announcement-item">
              <span><FaBullhorn style={{ marginRight: 8 }} />Annual Sports Day Registration</span>
              <span className="badge event">Event</span>
            </div>

            <div className="announcement-item">
              <span><FaBullhorn style={{ marginRight: 8 }} />Fee Payment Deadline</span>
              <span className="badge important">Important</span>
            </div>
          </div>

          <div className="chart-card fee-box">
            <div className="chart-title">Fee Collection Progress</div>
            <div className="circle">81%</div>

            <div className="fee-stats">
              <div>
                <div>Total Fees</div>
                <b>₹25,000</b>
              </div>
              <div>
                <div style={{ color: "#43e97b" }}>Collected</div>
                <b>₹20,150</b>
              </div>
              <div>
                <div style={{ color: "red" }}>Pending</div>
                <b>₹4,850</b>
              </div>
            </div>

            <div className="progress-bar">
              <div className="progress-fill"></div>
            </div>
          </div>

        </div>

        {/* RECENT ACTIVITIES */}
        <div className="chart-card activities">
          <div className="chart-title">Recent Activities</div>

          <div className="activity-item">
            <div className="activity-icon icon-blue">
              <FaUserPlus />
            </div>
            <div>
              <b>New Student Enrollment</b><br />
              <small>2 hours ago</small>
            </div>
          </div>

          <div className="activity-item">
            <div className="activity-icon icon-green">
              <FaMoneyBillWave />
            </div>
            <div>
              <b>Fee Payment Received</b><br />
              <small>3 hours ago</small>
            </div>
          </div>

          <div className="activity-item">
            <div className="activity-icon icon-pink">
              <FaClipboardCheck />
            </div>
            <div>
              <b>Attendance Updated</b><br />
              <small>5 hours ago</small>
            </div>
          </div>

          {/* NEW COMMUNICATION */}
          <div className="activity-item">
            <div className="activity-icon icon-orange">
              <FaCommentDots />
            </div>
            <div>
              <b>New Communication</b><br />
              <small>6 hours ago</small>
            </div>
          </div>

          {/* NEW TEACHER */}
          <div className="activity-item">
            <div className="activity-icon icon-blue">
              <MdPersonAddAlt />
            </div>
            <div>
              <b>New Teacher Onboarded</b><br />
              <small>1 day ago</small>
            </div>
          </div>

        </div>

      </div>
    </>
  );
}